import React from 'react';
import { connect } from 'react-redux';
import store from '../../../store';
// Gameplayer imports
import { GetGamePlayerInstance } from '../../../../GamePlayer';
import { setFullscreen, setPaused, setMuted } from '../../../actions/gameInfoActions';
// Shared imports
import settings from '../../../../settings';

class GameInfo extends React.Component {
    getInfo = () => {
        const { gameInfo } = this.props;

        // Calculate time if there's a time limit
        let currentTime = gameInfo.time;
        if (gameInfo.timeLimit > 0) {
            currentTime = gameInfo.timeLimit - gameInfo.time;
        }
        if (currentTime <= 0) currentTime = 0;
        const min = Math.floor(currentTime / 60);
        const sec = Math.floor(currentTime) % 60;
        const strTime = `${min < 10 ? `0${min}` : min}:${sec < 10 ? `0${sec}` : sec}`;

        // Calculate score if there's a score limit
        let strScore = '';
        if (gameInfo.pointsGoal > 0) {
            const curScore = gameInfo.score - gameInfo.pointsAtStartOfLevel;
            strScore = `${curScore}/${gameInfo.pointsGoal}`;
        } else {
            strScore = `${gameInfo.score}`;
        }

        return {
            score: strScore,
            lives: gameInfo.lives,
            health: gameInfo.health,
            time: strTime
        };
    };

    isFullScreen = () => {
        const { gameInfo } = this.props;

        return gameInfo.isFullscreen;
    };

    onFullScreenToggle = () => {
        const { dispatch } = this.props;
        let setToFullscreen = false;

        if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        } else {
            let element = document.getElementById('gamekit');
            if (!element) element = document.getElementById('gameplayer');

            if (element.requestFullscreen) {
                element.requestFullscreen();
                setToFullscreen = true;
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
                setToFullscreen = true;
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
                setToFullscreen = true;
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
                setToFullscreen = true;
            }
        }

        dispatch(setFullscreen(setToFullscreen));
    };

    isPaused = () => {
        const gameplayer = GetGamePlayerInstance();
        if (gameplayer !== null && gameplayer !== undefined) {
            return gameplayer.isGamePaused();
        }
        return false;
    };

    onPauseToggle = () => {
        const { dispatch } = this.props;

        const gameplayer = GetGamePlayerInstance();
        if (gameplayer !== null && gameplayer !== undefined) {
            gameplayer.togglePause();
        }

        dispatch(setPaused(gameplayer.isGamePaused()));
    };

    isMuted = () => {
        const gameplayer = GetGamePlayerInstance();
        if (gameplayer !== null && gameplayer !== undefined) {
            return gameplayer.isGameMuted();
        }
        return false;
    };

    onMuteToggle = () => {
        const { dispatch } = this.props;

        const gameplayer = GetGamePlayerInstance();
        if (gameplayer !== null && gameplayer !== undefined) {
            gameplayer.toggleMute();
        }

        dispatch(setMuted(gameplayer.isGameMuted()));
    };

    render() {
        const info = this.getInfo();

        const btnPauseClass = this.isPaused() ? 'play' : 'pause';

        const btnMuteClass = this.isMuted() ? 'muted' : 'unmuted';

        const btnFullscreenClass = this.isFullScreen() ? 'smallscreen' : 'fullscreen';

        return (
            <div className="top pointer-events-none" id="game-hud">
                <div className="game-hud-item game-hud-lives">
                    <img src={`${settings.assetsPath}img/icons/heart.png`} alt="Hart" className="game-hud-icon heart-image" />
                    <span className="game-hud-value lives">{info.lives}</span>
                </div>
                <div className="game-hud-item game-hud-health">
                    <div className="game-hud-icon health-bar-container">
                        <div className="health-bar" style={{ width: `${info.health}%` }} />
                    </div>
                    <span className="game-hud-value health">{info.health}</span>
                </div>
                <div className="game-hud-padding" />
                <div className="game-hud-item game-hud-points">
                    <img src={`${settings.assetsPath}img/icons/muntje.png`} alt="Muntje" className="game-hud-icon coin-image" />
                    <span className="game-hud-value">{info.score}</span>
                </div>
                <div className="game-hud-item game-hud-time">
                    <img src={`${settings.assetsPath}img/icons/klock.png`} alt="Klokje" className="game-hud-icon time-image" />
                    <span className="game-hud-value">{info.time}</span>
                </div>
                <div className="game-hud-item game-hud-extra">
                    <button type="button" className={`game-hud-button ${btnMuteClass}`} onClick={this.onMuteToggle} />
                    <button type="button" className={`game-hud-button ${btnPauseClass}`} onClick={this.onPauseToggle} />
                    <button type="button" className={`game-hud-button ${btnFullscreenClass}`} onClick={this.onFullScreenToggle} />
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    gameInfo: state.gameInfo
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GameInfo);
